module.exports = __webpack_public_path__ + "static/media/shareholder-app.88b01bfe.svg";